import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent implements OnInit {

  blogs: any = [];
  allBlogs: any = [];
  blog: any = {};
  blogId: any = '';
  recentBlogs: any = [];
  cate: any = [];
  categories: any = {};
  categoryList: any = [];
  siteUrl = environment.siteUrl;
  activeCategory: string = '';
  
  constructor(private appService: AppService) {

  }

  ngOnInit() {
    this.appService.getBlogs().subscribe((res: any) => {
      this.allBlogs = res;
      this.blogs = res;
      this.recentBlogs = JSON.parse(JSON.stringify(res)).splice(0, 4);
      this.blogs.forEach((item: any) => {
        if (!this.categories[item.category]) {
          this.categories[item.category] = 1;
        } else {
          this.categories[item.category] += 1;
        }
      });
      this.categoryList = Object.keys(this.categories);
    })
  }

  filterByCategory(category: string) {
    if (this.activeCategory === category) {
      // If clicking the same category again, show all blogs
      this.blogs = this.allBlogs;
      this.activeCategory = '';
    } else {
      // Filter blogs by the selected category
      this.blogs = this.allBlogs.filter((blog: any) => blog.category === category);
      this.activeCategory = category;
    }
  }

}
